import type { TrainingDiagram } from '@ukinfo/shared';
import { DiagramEditor } from './DiagramEditor';
import { cn } from '../ui';
import { SketchImageButton } from './ShareImageButton';

/**
 * Platz der Skizze im Uebungsformular: haengt den Skizzeneditor ein.
 *
 * Ohne Skizze bietet er „Skizze anlegen“ an, mit Skizze Feldwahl, Werkzeuge
 * und Eigenschaften. `onChange` liefert immer eine Schema-gueltige Skizze oder
 * `null` nach dem Entfernen. Mit Skizze steht darunter "Als Bild" (Vorschau teilen).
 * `flush`: am Handy ohne Rahmen und seitlichen Rand (der Editor nutzt die ganze Breite), ab `sm` wie sonst.
 */
export function DiagramField({
  value,
  onChange,
  disabled,
  title,
  flush,
}: {
  value: TrainingDiagram | null;
  onChange: (value: TrainingDiagram | null) => void;
  disabled?: boolean;
  /** Titel der Übung - steht auf dem Bild. */
  title?: string;
  flush?: boolean;
}): JSX.Element {
  return (
    <div
      data-testid="diagram-field"
      className={cn('bg-slate-50', flush ? 'py-2 sm:rounded-xl sm:border sm:border-slate-200 sm:p-3' : 'rounded-xl border border-slate-200 p-3')}
    >
      <DiagramEditor value={value} onChange={onChange} disabled={disabled} flush={flush} />
      {value && (
        <div className={cn('mt-2 flex justify-end', flush && 'px-3 sm:px-0')}>
          <SketchImageButton diagram={value} title={title?.trim() || 'Skizze'} />
        </div>
      )}
    </div>
  );
}
